import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-wo-configuration-tile',
    templateUrl: './wo.configuration.tile.component.html'
})
export class WoConfigurationTileComponent {
    @Input() companyId: number;
}
